<template>
  <container></container>
</template>

<script>
import container from "./container";
export default {
  name: "community",
  components: {
    container,
  },
  mounted() {
    console.log('触发了作品index');
    document.getElementById("home_top").style.display = "none";
  },
};
</script>

<style scoped lang="scss"></style>